import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useLocationContext, useLoading, useContent } from '../../../hooks/customHooks';
import Api from '../../../api/Api';
import PageSlug from '../../../components/PageSlug';
import LocationMap from '../../../components/LocationInterface/LocationMap';
import './LocationErrorPage.css';
import routeNames from '../../../constants/routeNames';
import Brand from '../../../components/Brand';
import Footer from '../../../components/Footer';
import SocialShares from '../../../components/SocialShares/SocialShares';
import WhatsappButton from '../../../components/WhatsappButton';
import { Link } from 'react-router-dom';
import routeHelper from '../../../helpers/routeHelper';
import { CampaignTypes } from '../../../constants/CampaignTypes';
import { JourneyTypes } from '../../../constants/JourneyTypes';

function LocationErrorPage() {
    const navigate = useNavigate();
    const {
        byUser,
        userLocation,
        getMyLocation,
        selectedLocation,
        nearbyLocations,
        updateLocationContext,
    } = useLocationContext();
    const [currentDistance, setCurrentDistance] = useState();
    const params = useParams();
    const [firstTime, setFirstTime] = useState(true);
    const [uniqueData, setUniqueData] = useState({});
    const { loading, setLoading } = useLoading();
    const [serve, setServe] = useState(null);

    const { content } = useContent();
    const s = content?.pages?.wrong_location?.settings;
    const c = content?.pages?.wrong_location?.content;
    const generic = content?.pages?.wrong_location?.generic;
    const g = content?.global_settings?.images;
    const showSocials = s?.footer_social;
    const whatsapp = s?.whatsapp;
    const [userCheckPassed, setUserCheckPassed] = useState(false);
    const [journeyFinished, setJourneyFinished] = useState(true);
    const { journey } = content;
    const location = useLocation();

    const forwardTo = state => {
        const { voucher, instantWin } = journey;
        let route = '';
        let props = { state };
        if (voucher && !uniqueData?.journeyContinues) {
            route = routeNames.REDEEM;
        } else if (instantWin) {
            route = `/instant-win/check/${params?.unique}`;
        } else {
            route = routeNames.REDEEM_SUCCESS;
        }
        navigate(route, props);
    };

    const handleLocateMe = () => {
        getMyLocation();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const { type } = content || {};
        const { unique } = params || {};

        if (
            type === CampaignTypes.GAME_AT_THE_END ||
            type === CampaignTypes.LOYALTY ||
            type === CampaignTypes.PREDICTION
        ) {
            Api.checkUserJourneyStatus(unique).then(res => {
                if (res?.result && res?.data) {
                    setJourneyFinished(true);
                } else {
                    let path;
                    switch (type) {
                        case CampaignTypes.PREDICTION:
                            path = `/prediction/location-check/${unique}`;
                            break;
                        case CampaignTypes.LOYALTY:
                            path = `/loyalty/location-check/${unique}`;
                            break;
                        case CampaignTypes.GAME_AT_THE_END:
                            path = `/game/location-check/${unique}`;
                            break;
                        default:
                            break;
                    }
                    if (path) {
                        navigate(path);
                    }
                }
            });
        } else {
            setJourneyFinished(true);
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        window.scrollTo({ top: 0 });
        (async () => {
            getMyLocation();
            if (params?.unique && params?.type && journeyFinished) {
                const uniqueResponse = await Api.checkUnique(params?.unique);
                let selectedVenue = await Api.getSelectedVenue(params?.unique);

                if (uniqueResponse?.result && uniqueResponse?.data?.journeyContinues) {
                    if (
                        uniqueResponse?.data?.destination === JourneyTypes.INSTANT_WIN &&
                        uniqueResponse?.data?.instantWinActivated
                    ) {
                        navigate(`/instant-win/check/${params?.unique}`);
                        return;
                    } else if (uniqueResponse?.data?.destination === JourneyTypes.GAME) {
                        navigate(`/game/location-check/${params?.unique}`);
                        return;
                    }
                }

                if (uniqueResponse?.data?.swiped && !journey?.instantWin) {
                    const state = {
                        unique: params?.unique,
                        type: params?.type,
                        venueId: selectedVenue.data._id,
                        firstTime: false,
                        uniqueData: uniqueResponse.data,
                        serve: uniqueResponse?.extra?.serve ?? uniqueResponse?.data?.serve,
                    };
                    forwardTo(state);
                    return;
                }

                if (uniqueResponse?.data) {
                    setFirstTime(loading && false);
                    setUniqueData(uniqueResponse.data);
                }
                if (uniqueResponse?.result) {
                    updateLocationContext({
                        selectedLocation: selectedVenue.data,
                        nearbyLocations: [selectedVenue.data],
                    });
                    setServe(uniqueResponse?.extra?.serve);
                    setUserCheckPassed(true);
                } else if (uniqueResponse.error.type) {
                    if (location?.state?.skipVoucher) {
                        if (uniqueResponse?.error.data?.instantWinActivated) {
                            navigate(`/instant-win/check/${params?.unique}`);
                        } else {
                            updateLocationContext({
                                selectedLocation: selectedVenue.data,
                                nearbyLocations: [selectedVenue.data],
                            });
                            setUserCheckPassed(true);
                        }
                    } else {
                        routeHelper(
                            uniqueResponse.error.type,
                            content,
                            navigate,
                            null,
                            uniqueResponse
                        );
                    }
                } else {
                    navigate(routeNames.ALREADY_REDEEMED, {
                        state: {
                            type: uniqueResponse?.error?.type,
                        },
                    });
                }
            } else {
                if (!selectedLocation) {
                    navigate(routeNames.HOME);
                }
            }
        })();
        setLoading(false);
        // eslint-disable-next-line
    }, [journeyFinished]);

    useEffect(() => {
        setLoading(true);
        if (byUser && userLocation) {
            if (selectedLocation && userCheckPassed) {
                (async () => {
                    setLoading(false);
                    let distanceResponse = await Api.getDistanceBetween({
                        from: `${userLocation.lat},${userLocation.lng}`,
                        to: `${selectedLocation.latitude},${selectedLocation.longitude}`,
                        venueId: selectedLocation._id,
                    });
                    if (distanceResponse && distanceResponse.result) {
                        setCurrentDistance(distanceResponse.data);
                        if (distanceResponse.data && distanceResponse.data.isInArea) {
                            // setLoading(false);
                            const state = {
                                ...location.state,
                                unique: params?.unique,
                                type: params?.type,
                                venueId: selectedLocation._id,
                                firstTime,
                                uniqueData,
                                serve: serve,
                                token: location?.state?.token,
                            };
                            forwardTo(state);
                        } else {
                            // setLoading(false);
                            //  navigate(routeNames.LOCATION_ERROR)
                        }
                    } else {
                        getMyLocation();
                    }
                })();
                // setLoading(false);
            }
        } else {
            getMyLocation();
        }
        setLoading(false);
        // eslint-disable-next-line
    }, [userLocation, selectedLocation, userCheckPassed]);

    const selectDifferentVenue = () => {
        window.location.href = location.state.selectDifferentVenueUrl;
    };

    return !loading ? (
        <div className={`page-wrapper ${s?.bg && g?.bg ? 'has-bg' : ''}`}>
            {s?.bg && g?.bg && (
                <div
                    className={`${s?.bg && g?.bg ? 'with-bg' : ''}`}
                    style={{ backgroundImage: s?.bg && g?.bg && `url(${g?.bg})` }}
                ></div>
            )}
            {s?.header && g?.header && <Brand image={g?.header} />}

            <main>
                {s?.logo && g?.logo && (
                    <section className="campaign-logo">
                        <Link to={routeNames.HOME} className="brand-logo">
                            <img className="header-title-image" alt="" src={g?.logo} />
                        </Link>
                    </section>
                )}

                <section className={`${s?.bg && g?.bg ? 'transparent-container' : ''}`}>
                    <PageSlug title={c?.title?.value} />
                    <p>{c?.description?.value}</p>
                    {/* <p>{c?.details?.value}</p> */}
                </section>

                <section
                    className={`main-content location-interface ${
                        s?.bg && g?.bg ? 'transparent-container' : ''
                    }`}
                >
                    <section className="padding-horizontal section-lite text-center section-distance ">
                        {userLocation && nearbyLocations && (
                            <LocationMap nearbyLocations={selectedLocation} clickable={false} />
                        )}
                        <p
                            className="location-away-text"
                            dangerouslySetInnerHTML={{ __html: generic?.you_are?.value }}
                        ></p>

                        <h2 className="distance-text">
                            {currentDistance && currentDistance?.distance} {generic?.away?.value}
                        </h2>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: c?.current_location_description?.value,
                            }}
                        ></p>
                        <div className="button-gorup">
                            <button
                                className="btn btn-brand btn-capitalize btn-wide"
                                onClick={handleLocateMe}
                                dangerouslySetInnerHTML={{ __html: c?.keep_location_button?.value }}
                            ></button>
                            {location?.state?.selectDifferentVenueUrl && (
                                <button
                                    className="btn btn-wide btn-outline btn-capitalize btn-different"
                                    onClick={selectDifferentVenue}
                                    dangerouslySetInnerHTML={{
                                        __html: c?.select_new_location_button?.value,
                                    }}
                                ></button>
                            )}
                        </div>
                    </section>
                </section>
                <section
                    className={
                        'transparent-container ' + (!showSocials && !whatsapp ? 'hidden' : '')
                    }
                >
                    {showSocials && <SocialShares></SocialShares>}
                    {whatsapp && <WhatsappButton />}
                </section>
                {s?.footer && (
                    <Footer className={`${s?.bg && g?.bg ? 'transparent-container' : ''}`} />
                )}
            </main>
        </div>
    ) : (
        ''
    );
}

export default LocationErrorPage;
